import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "popup-box",
  style: {
    "padding": "10px 0"
  }
};
var _hoisted_2 = {
  class: "text-center"
};
var _hoisted_3 = {
  class: "mb-20"
};
var _hoisted_4 = {
  class: "has-non-empty-bookings"
};
var _hoisted_5 = {
  class: "mt-20"
};
var _hoisted_6 = {
  class: "f-bold"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "close-btn",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.cancelClosingSales && _ctx.cancelClosingSales.apply(_ctx, arguments);
    })
  }, "x"), _createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.t("nav.close-sales")), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, _toDisplayString(_ctx.t("common.incomplete-bookings-warning")), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.t("common.confirm-closing-sales")), 1)])])]);
}